import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { MapEditorService } from './map-editor.service';

// Tools in map-overlay that affect the activity of one another
type ToolType = 'map-search-bar' | 'geo-search' | 'select-tour-type';

@Injectable({
    providedIn: 'root',
})
export class MapOverlayService {

    /** The currently active map-overlay tool (null if all are inactive) */
    private activeTool: ToolType = null;
    public activeToolChange: ReplaySubject<ToolType> = new ReplaySubject<ToolType>(1);

    constructor(private mapEditorService: MapEditorService){}

    /**
     * Update activeTool when relevant changes are made in- or outside of map-overlay
     * @param toolIsActive Denotes whether the tool in question has been activated or inactivated
     * @param toolType The type of the tool in question, otherwise the current tool is assumed (pass null to force deactivate all tools)
     * @returns 
     */
    public updateActiveTool(toolIsActive: boolean, toolType: ToolType = this.activeTool) {
        const forceDeactivateAll = !toolType;

        // If an active tool is now inactive, clear map and notify listeners
        if((this.activeTool && this.activeTool == toolType && !toolIsActive) || forceDeactivateAll) {
            this.mapEditorService.changeToSelectMode();
            this.activeTool = null;
            this.activeToolChange.next(this.activeTool);
            return;
        }

        // If an inactive tool is further inactive, do nothing
        if(!toolIsActive) return;

        // If an inactive tool is now active, clear map and notify listeners
        this.mapEditorService.changeToSelectMode();
        this.activeTool = toolType;
        this.activeToolChange.next(this.activeTool);
    }

    /**
     * Observe the currently active tool (null when all is inactive)
     */
    public watchActiveTool(): Observable<ToolType> {
        return this.activeToolChange.asObservable();
    }

}
